import { TitleColor } from '..';
import Text from '../Text';

const Education2013 = () => (
  <>
    <TitleColor text="Kurser 2013" smallTitle />
    <Text>
      <b>Ken Ramirez</b>
      <br />
      Weekendkursus den 23.-24. november 2013, med emnerne:
      <br />
      "Non-Food Reinforcers" og "Concept Training" (Modifier Cues, Adduction, and Mimicry), "Common
      Trainer Mistakes and Errors", "Non-formal Interactions", "Social Animals - Working with more
      than One Animal" og "Handling Animal Mistakes".
      <br />+ Seminar den 22. november 2013: "How Exotic Animals Taught me to be a Better Dog
      Trainer".
    </Text>
  </>
);

export default Education2013;
